<template>
  <div class="loading transition" ref="loadingWrap" :style="'height:'+(screenHeight+2)+'px;'">
    <div v-if="screenWidth>768">
      <div ref="loadingLeft1" class="tp-0 transition-slow loading-left1"></div>
      <div ref="loadingLeft2" class="tp-0 transition-slow loading-left2"></div>
      <div ref="loadingRight1" class="tp-0 transition-slow loading-right1"></div>
      <div ref="loadingRight2" class="tp-0 transition-slow loading-right2"></div>
      <fo-loadingSvg @finishCallback="finishCallback" class="loadingSvg"></fo-loadingSvg>
    </div>
    <div v-else>
      <div ref="loadingTop1" class="lf-0 transition-slow loading-top1"></div>
      <div ref="loadingTop2" class="lf-0 transition-slow loading-top2"></div>
      <div ref="loadingBottom1" class="lf-0 transition-slow loading-bottom1"></div>
      <div ref="loadingBottom2" class="lf-0 transition-slow loading-bottom2"></div>
      <fo-loadingSvg @finishCallback="finishCallback" class="loadingSvg"></fo-loadingSvg>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'loading',
  computed: {
    ...mapGetters([
      'scrollTop',
      'screenWidth',
      'screenHeight'
    ])
  },
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    finishCallback () {
      this.isShow = true
      setTimeout(() => {
        if (this.screenWidth > 768) {
          this.$refs.loadingLeft1.style.top = -(this.screenHeight + 1) + 'px'
          this.$refs.loadingLeft1.style.opacity = 1
          this.$refs.loadingLeft2.style.top = (this.screenHeight + 1) + 'px'
          this.$refs.loadingLeft2.style.opacity = 1
          this.$refs.loadingRight1.style.top = -(this.screenHeight + 1) + 'px'
          this.$refs.loadingRight1.style.opacity = 1
          this.$refs.loadingRight2.style.top = (this.screenHeight + 1) + 'px'
          this.$refs.loadingRight2.style.opacity = 1
        } else {
          this.$refs.loadingTop1.style.left = -this.screenWidth + 'px'
          this.$refs.loadingTop1.style.opacity = 1
          this.$refs.loadingTop2.style.left = this.screenWidth + 'px'
          this.$refs.loadingTop2.style.opacity = 1
          this.$refs.loadingBottom1.style.left = -this.screenWidth + 'px'
          this.$refs.loadingBottom1.style.opacity = 1
          this.$refs.loadingBottom2.style.left = this.screenWidth + 'px'
          this.$refs.loadingBottom2.style.opacity = 1
        }
      }, 500)
      setTimeout(() => {
        this.$refs.loadingWrap.style.background = 'transparent'
      }, 2000)
      setTimeout(() => {
        this.$emit('finishCallback')
      }, 2500)
    }
  }
}
</script>
<style>
.loading-left1 {
  background: #fff;
  width: 25%;
  left: 0%;
  height: 100%;
  position: absolute;
}
.loading-left2 {
  background: #fff;
  width: 25%;
  left: 25%;
  height: 100%;
  position: absolute;
}
.loading-right1 {
  background: #fff;
  width: 25%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
}
.loading-right2 {
  background: #fff;
  width: 25%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 75%;
}
.loading-top1 {
  background: #fff;
  height: 25%;
  width: 100%;
  position: absolute;
}
.loading-top2 {
  background: #fff;
  height: 25%;
  top: 25%;
  width: 100%;
  position: absolute;
}
.loading-bottom1 {
  background: #fff;
  height: 25%;
  width: 100%;
  position: absolute;
  top: 50%;
}
.loading-bottom2 {
  background: #fff;
  height: 25%;
  width: 100%;
  position: absolute;
  top: 75%;
}
.loading {
  background: rgba(0, 0, 0, 0.05);
}
.loadingSvg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/compos/Loading.vue